export default "__VITE_ASSET__908526cd__"